import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
    Cell,
} from "recharts";

type BrandData = {
    brand: string;
    cagr: number;
    rank: string;
};

type BrandCAGRChartProps = {
    data: BrandData[];
};

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <div
                style={{
                    backgroundColor: "black",
                    color: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: "5px",
                    boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                }}
            >
                <p style={{ margin: 0 }}>
                    <strong>{payload[0].payload.brand}</strong>
                </p>
                <p style={{ margin: 0 }}>CAGR: {payload[0].value.toFixed(2)}%</p>
            </div>
        );
    }

    return null;
};

const BrandCAGRChart: React.FC<BrandCAGRChartProps> = ({ data }) => {
    const colors = ["#54A7A8"];

    const sortedData = [...data]
        .sort((a, b) => b.cagr - a.cagr)
        .map((item, index) => ({
            ...item,
            color: colors[index % colors.length],
        }));

    const formatCAGR = (value: number) => `${value.toFixed(2)}%`;

    return (
        <ResponsiveContainer width="100%" height={800}>
            <BarChart
                layout="vertical"
                data={sortedData}
                margin={{
                    top: 20,
                    right: 100,
                    left: 150,
                    bottom: 5,
                }}
            >
                <XAxis
                    type="number"
                    domain={[0, "dataMax"]}
                    tickFormatter={formatCAGR}
                />
                <YAxis type="category" dataKey="brand" width={140} />
                <Tooltip cursor={false} content={<CustomTooltip />} />
                <Legend />
                <Bar dataKey="cagr" name="CAGR">
                    {sortedData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <LabelList dataKey="cagr" position="right" formatter={formatCAGR} />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default BrandCAGRChart;
